import Header from '@/components/Header'
import Footer from '@/components/Footer'
import YubiKeyVisual from '@/components/YubiKeyVisual'

function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section with Clear Instructions */}
      <main className="hero-gradient">
        <div className="max-w-6xl mx-auto px-6 py-20">


          {/* Main Message */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-black mb-6 text-gray-900 leading-tight">
              Welcome to Your<br />
              <span className="font-serif italic text-yubico-green-400">Secure Workplace</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Experience passwordless authentication with FIDO Pre-registered YubiKeys&reg;.
              No manual setup. No friction. Just instant, phishing-resistant access.
            </p>
          </div>

          {/* Clear Next Step Instructions Card */}
          <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
            {/* Card Header */}
            <div className="bg-gradient-to-r from-yubico-green-400 to-yubico-green-500 px-8 py-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                    <span className="text-2xl font-black text-yubico-green-400">1</span>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Next Step</h3>
                    <p className="text-yubico-green-50 text-sm">Ready to authenticate</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-8">
              {/* YubiKey Image with Animation */}
              <div className="mb-8">
                <YubiKeyVisual size="lg" showTouchIcon />
              </div>

              {/* Instruction Text */}
              <div className="text-center mb-8">
                <h4 className="text-xl font-bold text-gray-900 mb-2">
                  Insert Your YubiKey&reg; to Login
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  Your YubiKey&reg; is already registered and ready to use. Simply insert it into
                  your USB port and touch the gold sensor when prompted.
                </p>
              </div>

              {/* Step-by-step Quick Guide */}
              <div className="grid grid-cols-4 gap-4 mb-8">
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-yubico-green-400 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="iconoir-usb text-white text-2xl"></i>
                  </div>
                  <p className="text-sm font-medium text-gray-700">Insert YubiKey&reg;</p>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-yubico-green-400 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="iconoir-password-pass text-white text-2xl"></i>
                  </div>
                  <p className="text-sm font-medium text-gray-700">Enter PIN</p>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-yubico-green-400 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="iconoir-fingerprint text-white text-2xl"></i>
                  </div>
                  <p className="text-sm font-medium text-gray-700">Touch sensor</p>
                </div>
                <div className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-yubico-green-400 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="iconoir-shield-check text-white text-2xl"></i>
                  </div>
                  <p className="text-sm font-medium text-gray-700">Access granted</p>
                </div>
              </div>

              {/* CTA Button */}
              <a
                href="/api/auth/login"
                className="block w-full bg-[#005572] hover:bg-[#00445c] text-white font-bold py-4 px-8 rounded-xl text-lg transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-[#005572]/30 text-center"
              >
                Begin Secure Login &rarr;
              </a>

              {/* Technical Badge */}
              <div className="mt-6 flex items-center justify-center gap-3 text-sm text-gray-500">
                <span className="font-mono font-bold text-yubico-green-500">FIDO2</span>
                <span>&bull;</span>
                <span className="font-mono font-bold text-yubico-green-500">WebAuthn</span>
                <span>&bull;</span>
                <span className="font-mono font-bold text-yubico-green-500">Phishing-Resistant</span>
              </div>
            </div>
          </div>

          {/* Value Props */}
          <div className="mt-20 grid grid-cols-3 gap-6">
            <div className="text-center p-6 bg-white rounded-xl border border-gray-100 stat-card">
              <div className="text-4xl font-black text-yubico-green-400 mb-2">0 min</div>
              <p className="text-gray-600 font-medium">User Setup Time</p>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border border-gray-100 stat-card">
              <div className="text-4xl font-black text-yubico-green-400 mb-2">-92%</div>
              <p className="text-gray-600 font-medium">IT Support Tickets</p>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border border-gray-100 stat-card">
              <div className="text-4xl font-black text-yubico-green-400 mb-2">100%</div>
              <p className="text-gray-600 font-medium">Phishing Protection</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default HomePage
